const SET_TITLE = '[data-form-set-title]';

const findSetTitle = (element: Element | null): Element | null => {
  for (let node = element; node; node = node.parentElement) {
    for (
      let sibling = node.previousElementSibling, steps = 0;
      sibling && steps < 2;
      sibling = sibling.previousElementSibling, steps++
    ) {
      if (sibling.matches(SET_TITLE)) return sibling;
    }
  }
  return null;
};

export default findSetTitle;
